export const jpnDateFormat = (d) => {
  var str = d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
  return str;
};
